export function throwingMethods<Names extends string>(methodNames: Names[]): {
  [name in Names]: (...args: unknown[]) => never;
} {
  return Object.fromEntries(methodNames.map(name => [
    name,
    throwingFunction,
  ] as const));
}

export function throwingFunction(): never {
  throw new Error(
    'Tried to call dummy method. This probably means you are missing a React context provider.',
  );
}

